import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const USER_HISTORY_ENUMS = {};

export default {
  namespaced: true,
  state() {
    return {
      historyItems: [],
    };
  },
  mutations,
  actions,
  getters,
};
